'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var styles = require('@material-ui/styles');
require('@material-ui/core/BottomNavigationAction');
var useStoredState = require('../useStoredState/useStoredState.js');
require('@material-ui/icons/MenuRounded');
require('../DeviceProvider/DeviceProvider.js');
var useDevice = require('../DeviceProvider/useDevice.js');
var ShellContext = require('./ShellContext.js');
var AppBar = require('./AppBar.js');
var MobileAppBar = require('./MobileAppBar.js');
var MenuPanel = require('./MenuPanel.js');
var MobileMenuPanel = require('./MobileMenuPanel.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var MENU_CLOSED_WIDTH = 21;
var MENU_OPEN_WIDTH = 256;
var APP_BAR_HEIGHT = 56;
var MOBILE_APP_BAR_HEIGHT = 48;
var MOBILE_NAVIGATION_HEIGHT = 36;
var useStyles = styles.makeStyles(theme => ({
  main: {
    position: 'fixed',
    top: props => props.isMobile ? MOBILE_APP_BAR_HEIGHT : APP_BAR_HEIGHT,
    left: props => !props.hasMenu || props.isMobile ? 0 : props.menuIsOpen ? MENU_OPEN_WIDTH : MENU_CLOSED_WIDTH,
    right: 0,
    bottom: props => props.isMobile ? MOBILE_NAVIGATION_HEIGHT : 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    transition: "left 0.15s ease"
  },
  mobileNavigation: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    borderTop: "1px solid ".concat(theme.palette.divider)
  }
}));
/**
 * Content wrapper for public website.
 */

var Shell = _ref => {
  var {
    appBarContent,
    brandName,
    children,
    defaultMenuContent,
    defaultTitle = '',
    homeLink,
    logo,
    userMenu,
    mobileLogo,
    mobileUserMenu,
    mobileAppBarContent,
    mobileNavigation
  } = _ref;
  var {
    isMobile
  } = useDevice.useDevice();
  var [menuIsOpen, setMenuIsOpen] = useStoredState.useStoredState({
    key: 'shell-menu-is-open',
    initialValue: 'true'
  });
  var [menuContent, setMenuContent] = React__default['default'].useState(null);
  var [title, setTitle] = React__default['default'].useState(defaultTitle);
  var hasMenu = Boolean(menuContent);
  var classes = useStyles({
    isMobile,
    hasMenu,
    menuIsOpen: menuIsOpen === 'true'
  }); // Synchronize document title

  React__default['default'].useEffect(() => {
    document.title = title;
    return () => document.title = defaultTitle;
  }, [title]); // Load the shell with the default menu content.

  React__default['default'].useEffect(() => {
    if (defaultMenuContent) {
      setMenuContent(defaultMenuContent);
    }
  }, [defaultMenuContent]);

  function toggleMenu(desiredState) {
    var newState = desiredState !== null && desiredState !== void 0 ? desiredState : menuIsOpen === 'true' ? 'false' : 'true';
    setMenuIsOpen(newState);
  }

  var AppBarComponent = isMobile ? MobileAppBar.MobileAppBar : AppBar.AppBar;
  var logoToUse = isMobile ? mobileLogo !== null && mobileLogo !== void 0 ? mobileLogo : logo : logo;
  return /*#__PURE__*/React__default['default'].createElement(ShellContext.ShellContext.Provider, {
    value: {
      setMenuContent,
      setTitle,
      toggleMenu
    }
  }, /*#__PURE__*/React__default['default'].createElement(AppBarComponent, {
    logo: logoToUse,
    homeLink: homeLink,
    brandName: brandName,
    userMenu: isMobile ? mobileUserMenu : userMenu
  }, isMobile ? mobileAppBarContent : appBarContent), !isMobile ? /*#__PURE__*/React__default['default'].createElement(MenuPanel.MenuPanel, {
    isOpen: menuIsOpen === 'true',
    toggle: toggleMenu,
    hasContent: Boolean(menuContent)
  }, menuContent) : menuContent ? /*#__PURE__*/React__default['default'].createElement(MobileMenuPanel.MobileMenuPanel, {
    isOpen: menuIsOpen === 'true',
    toggle: toggleMenu
  }, menuContent) : null, /*#__PURE__*/React__default['default'].createElement("main", {
    className: classes.main
  }, children), isMobile && Boolean(mobileNavigation) && /*#__PURE__*/React__default['default'].createElement("nav", {
    className: classes.mobileNavigation
  }, mobileNavigation));
};
Shell.propTypes = {
  appBarContent: index.node,
  brandName: index.string,

  /** Content inside the shell. */
  children: index.node,
  defaultMenuContent: index.node,
  defaultTitle: index.string,
  homeLink: index.string,
  logo: index.string,
  user: index.object,
  userMenu: index.node,
  mobileLogo: index.string,
  mobileUserMenu: index.node,
  mobileAppBarContent: index.node,
  mobileNavigation: index.node
};

exports.Shell = Shell;
exports.default = Shell;
